// TODO: Delete this file once CPQ:PLI:ZeroPercentTax gate is ungated to 100%
// This file contains legacy tax display logic that will be replaced by the new ungated behavior
import { OPEN } from '../constants/Statuses';
export function getTaxDisplayConfig({
  status,
  isAutomatedSalesTaxEnabled,
  taxCalculationId,
  lineItems
}) {
  const hasAstWithTaxesCalculatedPreviously = status !== OPEN && !!isAutomatedSalesTaxEnabled && !taxCalculationId;
  const shouldDisplayLineItemTaxes = lineItems.some(lineItem => lineItem.taxAmount) && !(isAutomatedSalesTaxEnabled && !taxCalculationId) || !!hasAstWithTaxesCalculatedPreviously;
  let areTaxLabelsDifferent = false;
  if (shouldDisplayLineItemTaxes) {
    let previousTaxLabel = null;
    for (const lineItem of lineItems) {
      if (previousTaxLabel !== null && lineItem.tax && lineItem.tax.label !== previousTaxLabel) {
        areTaxLabelsDifferent = true;
        break;
      }
      previousTaxLabel = lineItem.tax && lineItem.tax.label;
    }
  }
  let lineItemTaxLabel = null;
  if (!areTaxLabelsDifferent) {
    for (const lineItem of lineItems) {
      if (lineItem.tax) {
        lineItemTaxLabel = lineItem.tax.label;
        break;
      }
    }
  }
  return {
    shouldDisplayLineItemTaxes,
    areTaxLabelsDifferent,
    lineItemTaxLabel
  };
}